import React from 'react';
import styles from '../styles/Feature.module.css';

function Feature() {
    const features = [
        {
            title: "リグの専門集団",
            description: "私たちParnasは、「必要なときに、必要なリグの知識とリソースを提供できる存在」を目指し、あえて総合型スタジオを志向せず、リギング領域に特化した事業を展開しています。",
        },
        {
            title: "あらゆるCGプロジェクトを支援",
            description: "Parnasは、アニメ制作で培った表現力、ゲーム開発で身につけた構造化の技術、短納期の広告案件で磨いた提案力を融合させ、あらゆるCGプロジェクトに貢献します。",
        },
        {
            title: "スピード対応",
            description: "私たちは、現場の「今、困っている」を解消することを大切にしています。納期や技術的なトラブルなど、フェーズを問わず迅速に状況を把握し、具体的な打開策をご提案します。"
        },
    ];

    return (
        <section className={styles.container}>
            <h2 className={styles.title}>FEATURE / 選ばれる理由</h2>
            <div className={styles.featureList}>
                {features.map((feature, index) => (
                    <div key={index} className={styles.featureItem}>
                        <div className={styles.itemHeader}>
                            <span className={styles.itemNumber}>CASE: {feature.id}</span>
                            <div className={styles.headerLine}></div>
                        </div>
                        <h3 className={styles.featureTitle}>{feature.title}</h3>
                        <p className={styles.featureDescription}>{feature.description}</p>

                        {/* 装飾用コーナーブラケット (四隅) */}
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Feature;
